import { css } from "styled-components";

import { Palette } from "../../../../core/styles/theme";

export const sideBarStyles = css`
    &.aevi-side-bar {
        width: 270px;
        top: 70px;
        padding-bottom: 20px;
        height: calc(100% - 70px);
        position: fixed;
        transition: left 0.3s ease;
        box-shadow: 15px 0 15px -15px rgba(0, 0, 0, 0.5);
        border-left: ${Palette.MidGray};
        border-right: ${Palette.MidGray};
        overflow: visible;
        overflow-x: hidden;
        overflow-y: auto;
        z-index: 1000;

        &.collapsed {
            width: 50px;
        }
    }

    @media screen and (max-width: 960px) {
        &.aevi-side-bar {
            width: 50px;
            &:hover {
                width: 270px;
            }
        }
    }
`;
